export type LightArtigo = {
  slug: string;
  titulo: string;
  resumo: string;
};

export const ARTIGOS_LIST_LIGHT: LightArtigo[] = [
  {
    slug: "como-calcular-das-mei-2026",
    titulo: "Como Calcular o DAS MEI 2026: Guia Completo com Tabela Atualizada",
    resumo: "Tabela completa 2026, fórmula de cálculo, diferença entre comércio/serviço/caminhoneiro, exemplos práticos e passo a passo no PGMEI. Com FAQ de 15 perguntas.",
  },
  {
    slug: "ferramentas-mei-kit-gratuito",
    titulo: "Ferramentas para MEI 2026: o kit gratuito definitivo",
    resumo: "Monte um kit de recursos digitais gratuitos para a rotina do MEI em 2026: DAS, NFS-e, limite de faturamento e controle de caixa sem custo.",
  },
  {
    slug: "desenquadramento-mei-como-agir",
    titulo: "Desenquadramento do MEI: causas, efeitos e como agir",
    resumo: "Faturou acima do limite ou violou alguma regra? Veja as causas, os prazos e como regularizar seu CNPJ ou migrar para ME.",
  },
  {
    slug: "mei-2026-cgsn-183",
    titulo: "MEI 2026: a mudança silenciosa da Resolução CGSN 183/2025 que pode desenquadrar seu CNPJ",
    resumo: "Como a CGSN 183/2025 muda o cálculo do faturamento para quem é MEI + CLT, novos valores do DAS em 2026 e o que fazer se perdeu a DASN-SIMEI.",
  },
  {
    slug: "portal-mei-guia-completo",
    titulo: "Portal MEI: como acessar, usar e não se perder nos serviços do governo",
    resumo: "Guia completo dos portais oficiais: Portal do Empreendedor, PGMEI, Gov.br, app MEI, DASN-SIMEI e mais.",
  },
  {
    slug: "o-que-e-mei",
    titulo: "O que é MEI? Entenda tudo sobre o Microempreendedor Individual",
    resumo: "Benefícios, obrigações, impostos, INSS, nota fiscal e perfis que se encaixam no MEI.",
  },
  {
    slug: "como-formalizar-mei",
    titulo: "Como formalizar seu MEI: passo a passo completo",
    resumo: "Critérios, atividades permitidas, abertura no Portal do Empreendedor e o que fazer logo depois.",
  },
  {
    slug: "das-boleto-mei",
    titulo: "DAS do MEI: como gerar, pagar e parcelar o boleto mensal",
    resumo: "PGMEI, app MEI, PIX, débito automático, parcelamento e tudo sobre vencimento e atrasos.",
  },
  {
    slug: "mei-pode-ter-funcionario",
    titulo: "MEI pode ter funcionário? Tudo sobre contratação de empregado pelo MEI",
    resumo: "Quantos empregados o MEI pode ter, salário, custos, eSocial, demissão e contratação de outro MEI.",
  },
  {
    slug: "mei-x-me-diferencas",
    titulo: "MEI x ME: qual é o melhor para o seu negócio? Entenda as diferenças",
    resumo: "Limites, impostos, sócios, funcionários e quando faz sentido migrar do MEI para a Microempresa.",
  },
  {
    slug: "parcelamento-dividas-mei",
    titulo: "Parcelamento de dívidas do MEI: como regularizar a situação",
    resumo: "Como parcelar DAS em atraso, programas especiais e como recuperar todos os direitos do MEI.",
  },
  {
    slug: "limite-faturamento-mei",
    titulo: "Limite de faturamento MEI: o que fazer ao chegar no teto",
    resumo: "R$ 81.000 por ano: o que acontece se ultrapassar, como calcular e como planejar a migração.",
  },
  {
    slug: "como-cancelar-mei-dar-baixa",
    titulo: "Como cancelar o MEI: passo a passo para dar baixa no CNPJ",
    resumo: "Quando cancelar, o que regularizar antes, passo a passo no Portal do Empreendedor e o que muda no INSS.",
  },
  {
    slug: "atividades-permitidas-mei",
    titulo: "Atividades permitidas para MEI: lista e como escolher a sua",
    resumo: "Mais de 600 atividades autorizadas, CNAEs, profissões não permitidas e como verificar a sua.",
  },
  {
    slug: "alvara-funcionamento-mei",
    titulo: "Alvará de funcionamento para MEI: quando é obrigatório e como obter",
    resumo: "Quando o MEI precisa de alvará, como solicitar pela prefeitura e quais outras licenças podem ser exigidas.",
  },
  {
    slug: "alterar-dados-mei",
    titulo: "Como alterar dados do MEI: nome fantasia, endereço e atividade",
    resumo: "Passo a passo gratuito no Portal do Empreendedor para atualizar nome, endereço e CNAEs.",
  },
  {
    slug: "nota-fiscal-mei",
    titulo: "Como emitir nota fiscal pelo MEI: guia completo",
    resumo: "Quando emitir, tipos de nota (NFS-e, NF-e, NFC-e) e como se cadastrar pela prefeitura ou SEFAZ.",
  },
  {
    slug: "mei-nome-sujo",
    titulo: "MEI com nome sujo: é possível abrir MEI com restrição no CPF?",
    resumo: "Sim, dá para abrir MEI mesmo negativado. Veja as limitações práticas e como se preparar.",
  },
  {
    slug: "reforma-tributaria-mei",
    titulo: "MEI e a Reforma Tributária: o que muda para o microempreendedor",
    resumo: "CBS, IBS, Imposto Seletivo e a transição até 2033 — entenda o que afeta o seu MEI.",
  },
  {
    slug: "mei-inss-aposentadoria",
    titulo: "MEI e INSS: como funciona a aposentadoria do microempreendedor",
    resumo: "Quanto o MEI contribui, benefícios e como complementar para se aposentar acima do mínimo.",
  },
  {
    slug: "conta-pj-mei",
    titulo: "MEI precisa de conta bancária PJ? Regras e vantagens",
    resumo: "Não é obrigatório por lei, mas separar as finanças do negócio é uma das melhores decisões do MEI.",
  },
  {
    slug: "mei-imposto-de-renda",
    titulo: "MEI precisa declarar Imposto de Renda? Entenda as regras",
    resumo: "DASN-SIMEI é uma coisa, IRPF é outra. Veja quando o MEI precisa fazer a declaração de PF.",
  },
  {
    slug: "beneficios-previdenciarios-mei",
    titulo: "Benefícios previdenciários do MEI: auxílio-doença, salário-maternidade e pensão",
    resumo: "Pagar o DAS dá acesso a uma rede de proteção que vai muito além da aposentadoria.",
  },
  {
    slug: "certificado-digital-mei",
    titulo: "Certificado digital para MEI: quando é obrigatório e como obter",
    resumo: "e-CPF ou e-CNPJ? Veja em quais situações é exigido, qual escolher e quanto custa.",
  },
  {
    slug: "migrar-mei-para-me",
    titulo: "Como migrar do MEI para ME: quando e como fazer a transição",
    resumo: "Chegou no teto ou quer crescer? Veja a transição para Microempresa sem perder histórico.",
  },
  {
    slug: "mei-e-commerce",
    titulo: "MEI e e-commerce: tudo que você precisa para vender online",
    resumo: "Marketplaces, loja própria, NF, limite de faturamento e dropshipping para o MEI.",
  },
  {
    slug: "mei-simples-nacional",
    titulo: "MEI e o Simples Nacional: como funciona a tributação do microempreendedor",
    resumo: "SIMEI, DAS fixo e isenções: por que é o regime tributário mais favorável do Brasil.",
  },
  {
    slug: "mei-feminino",
    titulo: "MEI feminino: direitos, benefícios e proteções para a mulher empreendedora",
    resumo: "Salário-maternidade, auxílio-doença, aposentadoria e crédito para a mulher MEI.",
  },
  {
    slug: "mei-inadimplente",
    titulo: "MEI inadimplente: o que acontece se você parar de pagar o DAS",
    resumo: "Multas, juros, perda de INSS, dívida ativa e como regularizar a situação.",
  },
  {
    slug: "mei-prestar-servico-pj",
    titulo: "MEI pode prestar serviço para empresa (PJ)? Saiba como funciona",
    resumo: "É legal sim. Veja como contratar com PJ e evitar a pejotização ilegal.",
  },
  {
    slug: "mei-clt-carteira-assinada",
    titulo: "MEI pode ter emprego com carteira assinada ao mesmo tempo?",
    resumo: "Dá para ser MEI e CLT. Veja regras, INSS e cuidados antes de abrir o CNPJ.",
  },
  {
    slug: "mei-pode-ter-socio",
    titulo: "MEI pode ter sócio? Limitações e o que fazer",
    resumo: "MEI não aceita sócio. Veja as alternativas (SLU, LTDA) para empreender em parceria.",
  },
  {
    slug: "como-obter-cartao-cnpj-rapido",
    titulo: "Como obter o Cartão CNPJ rápido: guia passo a passo",
    resumo: "Emita o Cartão CNPJ em menos de 5 minutos pelo site da Receita Federal, de graça, e evite golpes nessa hora.",
  },
  {
    slug: "vantagens-cartao-cnpj-para-empresas",
    titulo: "Vantagens do Cartão CNPJ para empresas e MEIs",
    resumo: "Conta PJ, crédito, notas fiscais, credibilidade e proteção patrimonial: por que o Cartão CNPJ é estratégico.",
  },
  {
    slug: "passo-a-passo-solicitar-cartao-cnpj",
    titulo: "Passo a passo para solicitar o Cartão CNPJ em PDF",
    resumo: "Guia atualizado para emitir e imprimir o Cartão CNPJ pela Receita Federal — no computador, celular ou app oficial.",
  },
  {
    slug: "cartao-cnpj-documentacao-necessaria-dicas",
    titulo: "Cartão CNPJ: documentação necessária e dicas",
    resumo: "Documentos para abrir e atualizar o CNPJ, como manter o cadastro em dia e evitar problemas com a Receita Federal.",
  },
  {
    slug: "cartao-cnpj-importancia-legal",
    titulo: "Cartão CNPJ: entenda a sua importância legal",
    resumo: "Por que o Cartão CNPJ é tão exigido: situação cadastral, obrigações legais e proteção do empreendedor.",
  },
  {
    slug: "microempreendedor-individual-nota-fiscal-eletronica",
    titulo: "Microempreendedor Individual e Nota Fiscal Eletrônica: Guia Completo 2026",
    resumo: "NFS-e nacional, novo CRT 4 e obrigatoriedade por tipo de cliente para o MEI em 2026.",
  },
  {
    slug: "inss-mei-2026",
    titulo: "INSS MEI 2026: valores, benefícios e como pagar o DAS",
    resumo: "Tabela do DAS-MEI 2026, 6 benefícios previdenciários e como complementar para se aposentar com mais.",
  },
  {
    slug: "obrigacoes-mensais-mei",
    titulo: "Obrigações mensais do MEI: checklist completo 2026",
    resumo: "DAS, nota fiscal, faturamento, cadastro e DASN-SIMEI em um checklist mensal prático.",
  },
  {
    slug: "simulador-emprestimo-mei",
    titulo: "Simulador de Empréstimo MEI 2026: parcelas, juros e melhores taxas",
    resumo: "Como simular empréstimo MEI, comparar Pronampe, fintechs e bancos e entender CET e carência antes de assinar.",
  },
  {
    slug: "simulador-maquininha",
    titulo: "Melhor Maquininha para MEI em 2026: Compare Taxas Antes de Comprar",
    resumo: "Descubra qual é a melhor maquininha para MEI em 2026. Compare Stone, InfinitePay, Mercado Pago, Ton, PagBank e SumUp com taxas atualizadas e use nosso simulador gratuito.",
  },
  {
    slug: "mei-vs-clt-2026",
    titulo: "MEI ou CLT em 2026: qual vale mais a pena? Compare com nosso simulador",
    resumo: "Isenção do IR até R$ 5.000, DAS-MEI 2026 e benefícios CLT lado a lado. Descubra qual regime entrega mais líquido para o seu perfil.",
  },
  {
    slug: "ia-cnae-mei-2026",
    titulo: "CNAE MEI 2026: como a IA ajuda você a escolher a atividade certa",
    resumo: "Descreva sua atividade em linguagem natural e descubra com IA o CNAE certo do seu MEI — com DAS, vantagens e riscos.",
  },
  {
    slug: "dasn-simei-declaracao-anual",
    titulo: "Declaração Anual do MEI (DASN-SIMEI) 2026: passo a passo completo",
    resumo: "Prazo, passo a passo, multa de R$ 50, como declarar atrasado e como corrigir uma DASN-SIMEI já entregue.",
  },
  {
    slug: "entregador-mercado-livre-mei",
    titulo: "Como abrir MEI para ser entregador do Mercado Livre: guia completo com CNAE certo e passo a passo",
    resumo: "CNAE correto (5320-2/02), como abrir o CNPJ no Portal do Empreendedor, cadastro na plataforma e quanto custa ser MEI entregador.",
  },
  {
    slug: "irpf-mei-2026",
    titulo: "IRPF do MEI 2026: Como Declarar o Lucro no Imposto de Renda Sem Cair na Malha Fina",
    resumo: "Calcule a parcela isenta (8%, 16% ou 32% da receita bruta), preencha as fichas certas do IRPF e evite a malha fina da Receita Federal.",
  },
  {
    slug: "gestao-financeira-mei",
    titulo: "Gestão Financeira para MEI 2026: Fluxo de Caixa, Controle e Ferramentas Gratuitas",
    resumo: "Separe contas pessoais e empresariais, monte um fluxo de caixa, defina o pró-labore e controle o limite de faturamento com ferramentas gratuitas.",
  },
  {
    slug: "credito-emprestimo-mei-2026",
    titulo: "Empréstimo para MEI 2026: Pronampe, BNDES e Como Conseguir Crédito com Taxas Baixas",
    resumo: "Guia completo de crédito para MEI: Pronampe (SELIC + 6%), BNDES Microcrédito, Cartão BNDES, fintechs e como aumentar as chances de aprovação.",
  },
  {
    slug: "emprestimo-caixa-mei",
    titulo: "Empréstimo Caixa para MEI 2026: Como Pedir Crédito de Até R$ 21 Mil Passo a Passo",
    resumo: "Linhas da Caixa para MEI, requisitos, documentos, passo a passo do pedido e como aumentar a chance de aprovação.",
  },

  {
    slug: "marketing-digital-mei",
    titulo: "Marketing Digital para MEI 2026: Como Vender pelo Instagram, WhatsApp e Google",
    resumo: "Estratégias práticas de marketing digital para MEI: perfil comercial no Instagram, catálogo no WhatsApp Business e Google Meu Negócio.",
  },
  {
    slug: "nanoempreendedor-reforma-tributaria",
    titulo: "Nanoempreendedor e Reforma Tributária 2026: O que Muda para o MEI",
    resumo: "O MEI vai acabar? O que é o nanoempreendedor? Como o DAS muda com CBS e IBS? Nota fiscal obrigatória em 2027? Tudo explicado com base na legislação vigente.",
  },
  {
    slug: "infinitepay-vale-a-pena",
    titulo: "InfinitePay Vale a Pena para MEI em 2026? Taxas, CPF e Análise Completa",
    resumo: "Saiba se a maquininha InfinitePay vale a pena para o seu MEI ou CPF em 2026. Analisamos taxas, tecnologia InfiniteTap, conta digital e prós/contras.",
  },
];
